import { useTranslation } from '@frontend/i18n';
import { Link } from '@frontend/weave-router';
import { theme } from '@frontend/theme';
import { Heading, TextLink } from '@frontend/design-system';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <section
      css={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}
    >
      <Heading css={{ marginBottom: theme.spacing(1) }}>{t('404 - Page Not Found')}</Heading>
      <TextLink as={Link} to={'/home/dashboard'}>
        {t('Go home')}
      </TextLink>
    </section>
  );
}
